import { ref, readonly } from 'vue'

const isVisible = ref(false)
const message = ref('')

export function useSnackbar() {
  const showSnackbar = (newMessage: string) => {
    message.value = newMessage
    isVisible.value = true
  }

  const closeSnackbar = () => {
    isVisible.value = false
  }

  return {
    isVisible,
    message: readonly(message),
    showSnackbar,
    closeSnackbar
  }
}
